import { type PartialDeep } from 'type-fest';

import { type CanvasElementFrom } from '@blaze-runtime/engine-domain';
import { type BlazeSchema } from '@blaze-shared/schema-domain';

import { type DefinitionMapper } from '../../../ai';
import { type CanvasElementDefinition } from '../../../canvas-elements/element-definition';

import { type RadioDefinition } from './radio.definition';

export class RadioDefinitionMapper implements DefinitionMapper<'radio'> {
  readonly type = 'radio';

  extract(
    element: CanvasElementFrom<'radio'>,
    _schemas: Readonly<Record<string, BlazeSchema>>,
    _definition: CanvasElementDefinition<'radio'>,
  ): PartialDeep<RadioDefinition> {
    const { title, radio } = element.props.content;

    return {
      label: title?.label,
      showLabel: title?.enabled,
      iconName: title?.icon,
      tooltip: title?.tooltip,
      isReadOnly: radio?.readonly,
      styleName: element.props.styleConfig?.styleName,
    };
  }
}
